<template>
  <div class="TileDataUKCountryPrognose">
    <TileDataContent
      :fids="fids"
      :forecast-label="forecastLabel"
      :dataset="dataset"
      :data-by-id="dataById"
    >
      <template #sub-title>
        <p v-if="municipalityName">
          <b>{{ municipalityName }}</b>
        </p>
      </template>

      <template #content-header>
        <TileDataContentHeader />
      </template>

      <template #content>
        <TileDataContentRowTwoColumn>
          <template #first-column>
            {{ $t('components.map.tiles.UK_forecast.projectedEVs') }}
          </template>
          <template #second-column>
            {{ formatNumber(getRaw(`aantal_evs_${year}`)) }}
          </template>
        </TileDataContentRowTwoColumn>

        <TileDataContentRowTwoColumn>
          <template #first-column>
            {{ $t('components.map.tiles.UK_forecast.acDemand') }}
          </template>
          <template #second-column>
            {{ formatNumber(getRaw(`ac_vraag_kw_${year}`)) }}
          </template>
        </TileDataContentRowTwoColumn>

        <TileDataContentRowTwoColumn>
          <template #first-column>
            {{ $t('components.map.tiles.UK_forecast.dcDemand') }}
          </template>
          <template #second-column>
            {{ formatNumber(getRaw(`dc_vraag_kw_${year}`)) }}
          </template>
        </TileDataContentRowTwoColumn>
      </template>

      <template #footer>
        ID: {{ fids[0] }}
      </template>
    </TileDataContent>
  </div>
</template>

<script>
import TileDataContent from '@/components/map/tiles/TileDataContent'
import TiledataMixin from '@/mixins/map/tiledata-mixin'
import TileDataContentHeader from '@/components/map/tiles/TileDataContentHeader'
import TileDataContentRowTwoColumn from '@/components/map/tiles/TileDataContentRowTwoColumn'

export default {
  name: 'TileDataUKCountryPrognose',
  components: {
    TileDataContentRowTwoColumn,
    TileDataContentHeader,
    TileDataContent,
  },
  mixins: [TiledataMixin],
  computed: {
    municipalityName() {
      return this.getString('gemeentenaam')
    },
  },
  methods: {
    getRaw(field) {
      const fid = this.fids && this.fids[0]
      if (!fid || !this.dataById || !this.dataById[fid]) return 0
      const val = this.dataById[fid][field]
      const num = Number(val)
      return isNaN(num) ? 0 : num
    },
    getString(field) {
      const fid = this.fids && this.fids[0]
      if (!fid || !this.dataById || !this.dataById[fid]) return ''
      return this.dataById[fid][field] || ''
    },
    formatNumber(value, decimals = 0) {
      if (decimals === 0) return new Intl.NumberFormat().format(Math.round(value))
      return new Intl.NumberFormat(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(value)
    },
  },
}
</script>

<style>
.TileDataUKCountryPrognose td {
  white-space: nowrap;
  vertical-align: middle;
}
</style>
